import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { initTheme } from '@chametw/ui/composables/useTheme';
import { apiClient } from './lib/api-client';
import '@chametw/ui/tokens.css';
import '@chametw/ui/base.css';
import './styles/admin.css';

initTheme();

const app = createApp(App);
app.use(createPinia());

apiClient.onUnauthenticated(() => {
  void router.replace({ name: 'login' });
});

app.use(router);
app.mount('#app');
